import PropTypes from 'prop-types';

const Services = ({data}) => {
  return (
    <div className={'w-full flex justify-center items-center lg:px-20 px-5 bg-primary-950'}>
      <div className={'max-w-6xl py-4'}>
        <h1 className={'playfair-display-medium font-bold lg:text-6xl text-3xl mb-4 text-secondary-300'}>Our Services</h1>
        {data.services.map((service, index) => (
          <div key={index} className={'mb-8 shadow-md bg-primary-400 rounded-3xl lg:p-5 p-4'}>
            <div className={`flex flex-col md:flex-row ${index % 2 === 0 ? '' : 'md:flex-row-reverse'}`}>
              <div className={'w-full md:w-1/2 py-4 px-3'}>
                <h2 className={'lg:text-5xl text-3xl font-bold lg:mb-8 mb-4 playfair-display-medium text-secondary-300'}>{service.title}</h2>
                <p className={'mt-4 lg:text-lg font-semibold text-gray text-justify'}>{service.description}</p>
              </div>
              <div className={'w-full md:w-1/2 p-4 h-80'}>
                <img src={service.image} alt={service.title} className={'w-full h-full object-cover rounded-lg'} />
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

Services.propTypes = {
  data: PropTypes.shape,
};

export default Services;
